import React from "react";
import { Modal, Backdrop, Fade } from "@mui/material";
import "./VideoPlayerModal.css";

// Extract video ID from YouTube URL
const extractVideoId = (url) => {
    const match = url.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
    return match ? match[1] : null;
};

const VideoPlayerModal = ({ 
    open, 
    onClose, 
    videoUrl, 
    videoTitle, 
    videoDescription,
    direction = "rtl" 
}) => {
    const videoId = extractVideoId(videoUrl);

    return (
        <Modal
            open={open}
            onClose={onClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ 
                timeout: 500,
                style: { backgroundColor: 'rgba(0, 0, 0, 0.85)' }
            }}
        >
            <Fade in={open}>
                <div className={`video-modal-content ${direction}`}>
                    <div className="video-modal-header">
                        <h3 className="video-modal-title">{videoTitle}</h3>
                        <button className="video-modal-close" onClick={onClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    
                    {videoId && (
                        <>
                            <div className="video-modal-player">
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    title={videoTitle}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            
                            {videoDescription && (
                                <div className="video-modal-description">
                                    <p>{videoDescription}</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Fade>
        </Modal>
    );
};

export default VideoPlayerModal;















